// extracted by mini-css-extract-plugin
export default {"project-settings-container":"ProjectSettings_project-settings-container__tyZV+","on-target-icon":"ProjectSettings_on-target-icon__uvdsV"};